export default function isDueDatePassed(date: string): boolean {
  const localDate = new Date()
  const dueDate = new Date(date)

  return localDate.getTime() > dueDate.getTime()
}
